export enum FeaturesEnum {
  INSCRIPTION_AUTONOME = 'inscription-autonome',
}
